import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { BaasAppState, BaasI18n } from '@lvflanders/bar';

import { BAR_LOCALHOST } from '../constants/tokens.constants';
import { BarCoreService } from '../services/bar-core.service';

export function barZoneGuard(...zones: string[]): CanActivateFn {
    return async () => {
        const appState = inject(BaasAppState);
        const core = inject(BarCoreService);
        const i18n = inject(BaasI18n);
        const localhost = inject<boolean>(BAR_LOCALHOST);
        let result = false;

        if (zones != null && zones.length > 0 && appState.basiscontext != null && appState.basiscontext.zone != null && appState.basiscontext.zone.length > 0) {
            result = zones.indexOf(appState.basiscontext.zone) > -1;
        }

        if (!result) {
            if (!localhost) {
                await core.navigateHome();
            } else {
                const errorMessage = i18n.get('DOMAIN_BAAS_CORE.ZONES_NOT_ALLOWED', { zones: zones.join() });
                console.error(errorMessage);
                const error = new Error(errorMessage);
                core.errorOccurred.emit(error);
            }
        }

        return result;
    };
}
